export class KolumnaSpisuFiltrowanie {
    kolumna: string;
    wartoscSzukaj: string;
}